import { client } from "common-lib";

const baseUrl = "/epoch-model";

export const getEpochModels = async (params?: { page?: number; pageSize?: number; project_id: number }) => {
  try {
    const response = await client.get(`${baseUrl}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
